import React from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";
import { setMultiShopSwitch, store } from "@components/VerticalLayout/store";

import { CustomIconsComponent } from "./CustomIcons";
import PageTitle from "@components/Common/PageTitle";
import NotAuthorizationPage from "@components/VerticalLayout/NotAuthorizationPage";
import CardSpinnerWrapper from "@components/Common/CardSpinnerWrapper";
import AccountIdentifier from "./AccountIdentifier";
import { setEntityDetails } from "../../redux/globalSlice";
import { useDispatch, useSelector } from "react-redux";

type CustomColumnProps = {
    indexOFColumn: number;
    columnName: string;
    customJsx: React.ReactNode;
};

export function Compte() {
    const { t, i18n } = useTranslation();
    const { franchiseID } = useSnapshot(store);
    const dispatch = useDispatch();
    const [filterActive, setLocalFilterActive] = React.useState(false);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [isHaveAccess, setIsHaveAccess] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const entityDetails = useSelector(
        (state: any) => state.global.entityDetails
    );

    const uidEntity = localStorage.getItem("Uid_Entitie_User");
    const uuidUser = localStorage.getItem("uuidUser");

    const urlApiEntity = `${process.env.REACT_APP_ACCESS_API_URL}/entityv1/${uidEntity}/${uuidUser}`;
    const urlApi = `${process.env.REACT_APP_ACCESS_API_URL}/accounts/${uidEntity}/${uuidUser}`;

    React.useEffect(() => {
        const entityCached: any = entityDetails;

        const fetchEntityData = async () => {
            try {
                console.log("eee", entityDetails);
                const response = await fetch(urlApiEntity);
                const data = await response.json();

                const entity = data.data?.[0];
                console.log("entity: ", entity);
                if (!entity) return;

                dispatch(setEntityDetails(entity));
                localStorage.setItem("i18nextLng", i18n.language);

                // Mise à jour Valtio store
                setMultiShopSwitch(
                    franchiseID,
                    entity[t("Commercial name")] ?? entity["Nom commercial"]
                );
            } catch (error) {
                console.error("Erreur API entity:", error);
            }
        };

        if (Object.keys(entityCached).length === 0) {
            fetchEntityData();
        } else {
            try {
                const entity = entityCached;
                setMultiShopSwitch(
                    franchiseID,
                    entity[t("Commercial name")] ?? entity["Nom commercial"]
                );
            } catch (err) {
                console.log("There's an error ", err);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlApiEntity, franchiseID, i18n.language, t]);

    React.useEffect(() => {
        const accessCached = null;

        const fetchAccess = async () => {
            try {
                const response = await fetch(urlApi);
                const result = await response.json();

                const hasAccess = result.data.length > 0;
                setIsHaveAccess(hasAccess);
            } catch (error) {
                console.error("Erreur API access:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (accessCached !== null) {
            setIsHaveAccess(accessCached);
            setIsLoading(false);
        } else {
            fetchAccess();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        setDataIsUpdated(true);
    }, [i18n.language]);

    const arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: 8,
            columnName: t("Identifier"),
            customJsx: AccountIdentifier,
        },
        {
            indexOFColumn: 99,
            columnName: t("Actions"),
            customJsx: (e: any) => <CustomIconsComponent e={e} />,
        },
    ];
    return (
        <React.Fragment>
            <PageTitle title={t("Home")} />
            {!isLoading ? (
                !isHaveAccess ? (
                    <>
                        {" "}
                        compte
                        <NotAuthorizationPage />
                    </>
                ) : (
                    <div
                        className="page-content__clz"
                        style={{ width: "100%" }}
                    >
                        <h2 className="ml-5 mt-3">{t("Choose an account")}</h2>
                        <div
                            className="card"
                            style={{ padding: "20px", margin: "9px" }}
                        >
                            <DynamicTable
                                url={
                                    process.env.REACT_APP_VERIFY ===
                                        "localhost" ||
                                    process.env.REACT_APP_VERIFY === undefined
                                        ? "./user.json"
                                        : urlApiEntity
                                }
                                requestHeader={{
                                    "Accept-Language": i18n.language,
                                }}
                                canExpand={true}
                                setDataIsUpdated={setDataIsUpdated}
                                dataIsUpdated={dataIsUpdated}
                                showFilter
                                canSelect={false}
                                setLocalFilterActive={setLocalFilterActive}
                                filterActive={filterActive}
                                actionColumn={() => <></>}
                                arrayOfCustomColumns={arrayOfCustomColumns}
                                canResize
                                showGlobalFilter
                                elevationTable={1}
                                name="Choice"
                                minHeight={"500px"}
                                maxHeight={"500px"}
                            />
                        </div>
                    </div>
                )
            ) : (
                <CardSpinnerWrapper />
            )}
        </React.Fragment>
    );
}
